export const onlyAdmins = 'only_admins';
export const adminsAndSalespeople = 'admins_and_salespeople';
export const specificUsers = 'specific_users';

export interface LabelValue {
  label: string;
  value: string;
  tooltip?: string;
}

export const Options: LabelValue[] = [
  {
    label: 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.ONLY_ADMINS',
    value: onlyAdmins,
  },
  {
    label: 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.ADMINS_AND_SALES',
    value: adminsAndSalespeople,
  },
  {
    label: 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.SPECIFIC_ADMINS',
    value: specificUsers,
    tooltip: 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ORDER_TRIGGER.SALES_RUNNABLE_DESCRIPTION',
  },
];

export function calculateDropdownValueFromJsonData(salesRunnable: boolean, onlyAllowedUsers: string[]): string {
  if (onlyAllowedUsers?.length > 0) {
    return specificUsers;
  } else if (salesRunnable) {
    return adminsAndSalespeople;
  } else {
    return onlyAdmins;
  }
}
